import React, { useEffect, useState } from 'react';
import { Col, Layout, Progress, Row, Button, Image, Tooltip } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import PreviewSidebar from '../component/modal/PreviewSidebar';
import Question from '../component/Question';
import { Images } from '../../../controller/Images';
import { useTestStore } from '../../../store/testReducer';
import { useNavigate } from 'react-router-dom';
import { getAdminDetail } from '../../../controller/localStroageHandler';

const { Content, Header } = Layout;

const Preview = () => {
  const [menuItemValue, setMenuItemValue] = useState(0);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const { questions } = useTestStore((state) => state);
  const [menuItem, setMenuItem] = useState([]);
  const [questionData, setQuestionData] = useState(questions);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const userdetail = getAdminDetail();
  const navigate = useNavigate();
  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };
  useEffect(() => {
    let data = questions?.map((val) => {
      return {
        name: val?.section,
        complete: 0,
      };
    });
    setMenuItem(data);
  }, []);

  return (
    <Layout className='w-100 h-100 bg-white'>
      <PreviewSidebar
        menuItemValue={menuItemValue}
        toggleDrawer={toggleDrawer}
        drawerVisible={drawerVisible}
        menuItem={menuItem}
      />
      <Layout>
        <Content className='bg-white w-100  overflow-y-auto'>
          <Header
            className='bg-white d-lg-none d-flex align-items-center justify-content-between gap-2 border-bottom'
            style={{ paddingLeft: '5px', paddingRight: '5px' }}
          >
             <div className=' d-block gap-2 d-lg-none '>
              <Button
                type='text'
                icon={<MenuOutlined />}
                onClick={toggleDrawer}
                className='d-lg-none'
              />
             <Image
                      src={userdetail?.organization_id?.logo||Images.logo}
                      alt=''
                      className='logo'
                      height={40}
                      preview={false}
                    />
            </div>
          </Header>
          <Row gutter={[12, 12]}>
            <Col xl={15} lg={14} md={12} sm={12} xs={24} className=''></Col>
            <Col xl={9} lg={10} md={12} sm={12} xs={24}>
              <Row
                gutter={[12, 12]}
                className='h-100 d-flex align-items-end p-2'
              >
                <Col span={12}>
                  {/* <Button
                    type='default'
                    className='text-color-custom w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
                  >
                    Save
                  </Button> */}
                </Col>
                <Col span={12}>
                <Button
                    type='default'
                    className='text-color-custom w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
                 onClick={()=>navigate(-1)}
                 >
                    Back to Edit
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <div className='w-100 h-100 p-lg-4 p-sm-2 p-md-3 custom-question-page-container'>
            <Question
              questionData={questionData}
              setQuestionData={setQuestionData}
              currentQuestionIndex={currentQuestionIndex}
              setCurrentQuestionIndex={setCurrentQuestionIndex}
              setMenuItemValue={setMenuItemValue}
              menuItemValue={menuItemValue}
            />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Preview;
